import { render } from "./AllExportsReports.vue?vue&type=template&id=5d7387c8&ts=true"
import script from "./AllExportsReports.vue?vue&type=script&lang=ts"
export * from "./AllExportsReports.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Users\\khale\\CookiesBIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__